import * as Sentry from '@sentry/react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createRouter, RouterProvider } from '@tanstack/react-router';
import './i18n';
import './index.css';
import { routeTree } from './routeTree.gen';
import { ErrorBoundary } from './components/ErrorBoundary';
import { initAnalytics } from './lib/analytics';

type AppConfig = {
  gaMeasurementId: string | null;
  sentryDsn: string | null;
  appEnv: string;
};

fetch('/api/config')
  .then((r) => r.json() as Promise<AppConfig>)
  .then(({ gaMeasurementId, sentryDsn, appEnv }) => {
    if (sentryDsn) {
      Sentry.init({ dsn: sentryDsn, environment: appEnv });
    }
    if (gaMeasurementId) initAnalytics(gaMeasurementId);
  })
  .catch(() => undefined);

const router = createRouter({ routeTree });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <RouterProvider router={router} />
    </ErrorBoundary>
  </StrictMode>,
);
